(function () {
  function init(root) {
    if (root.dataset.abpReady) return;
    root.dataset.abpReady = '1';
    var slider = root.querySelector('[data-abp-slider]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-abp-thumb]'));
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var s = slider && slider.children[i];
        if (s) slider.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      });
    });
    if (slider) {
      slider.addEventListener('scroll', function () {
        var i = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }, { passive: true });
    }
    var prices = root.querySelectorAll('[data-abp-price]');
    var names = root.querySelectorAll('[data-abp-name]');
    var updateUrl = root.dataset.updateUrl === 'true';
    root.querySelectorAll('input[name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        prices.forEach(function (el) { el.textContent = r.dataset.price; });
        names.forEach(function (el) { el.textContent = r.dataset.name; });
        if (updateUrl) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u.toString()); } catch (e) {}
        }
      });
    });
    var cta = root.querySelector('[data-abp-cta]');
    var bar = root.querySelector('[data-abp-sticky]');
    if (cta && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(cta);
    }
  }
  function all() { document.querySelectorAll('.abp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();